import React from "react";
import logo from "../../Assets/logo.png";
import resume from "../../Assets/Resume/Aneeq-Ullah-Khan_Resume.pdf";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <React.Fragment>
      <nav className="navbar sticky-top navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            {/* &nbsp;
            <div className="logo">
              <h1 className="title">Aneeq Ullah Khan</h1>
            </div> */}
            <img src={logo} alt="" height="auto" width="100%" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="bi-three-dots-vertical"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/projects">
                  Projects
                </Link>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Services &nbsp;
                  <span class="custom-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-chevron-down"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                      />
                    </svg>
                  </span>
                </a>
                <ul className="dropdown-menu bg-dark rainbow-border">
                  <li>
                    <br />
                    <Link className="dropdown-item" to="/coming-soon">
                      <img
                        width="30"
                        height="30"
                        src="https://img.icons8.com/pastel-glyph/64/website--v2.png"
                        alt="website--v2"
                      />
                      &nbsp; Web Design And Development
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/coming-soon">
                      <img
                        width="30"
                        height="30"
                        src="https://img.icons8.com/cotton/64/domain.png"
                        alt="domain"
                      />
                      &nbsp; Web App Development
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/coming-soon">
                      <img
                        width="30"
                        height="30"
                        src="https://img.icons8.com/color/48/google-firebase-console.png"
                        alt="google-firebase-console"
                      />
                      &nbsp; Web App With Firebase Development
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/coming-soon">
                      <img
                        width="30"
                        height="30"
                        src="https://img.icons8.com/color/48/api.png"
                        alt="api"
                      />
                      &nbsp; Restful API's Development
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/services">
                      <img
                        width="30"
                        height="30"
                        src="https://img.icons8.com/fluency/48/more.png"
                        alt="more"
                      />
                      &nbsp; All Services
                    </Link>
                    <br />
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact &nbsp;
                </Link>
              </li>
              <li className="nav-item px-2">
                <a href={resume}>
                  <button className="btn-login">DOWNLOAD RESUME</button>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
